
import {
  defineComponent,
  inject
} from 'vue'
import { MaxAttachFileMega } from '@/config'
import IconButton from '@/components/atoms/button/iconButton.vue'
import DropArea from '@/components/molecules/dropArea.vue'
import LoadingImage from '@/components/atoms/loadingImage.vue'
import MultiLineEditBox from '@/components/molecules/editbox/multiLineEditBox.vue'
import { UseErrorKey, UseErrorType } from '@/composables/useError'
import { UseKarteKey, UseKarteType } from '@/composables/karte/useKarte'
import { UseFileDBKey, UseFileDBType } from '@/composables/karte/useFileDB'
import { DropAreaFileType } from '@/composables/types'

export default defineComponent({
  name: 'karte-parts-image-and-text',
  components: {
    LoadingImage,
    MultiLineEditBox,
    IconButton,
    DropArea
  },
  props: {
    resultIndex: {
      type: Number,
      required: true
    },
    kartePartsIndex: {
      type: Number,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    const { append } = inject(UseErrorKey) as UseErrorType
    const {
      karteResult: {
        fileFileId,
        text
      },
      addKarteFile,
      deleteKarteFile
    } = inject(UseKarteKey) as UseKarteType
    const {
      fileMap
    } = inject(UseFileDBKey) as UseFileDBType

    const onImage = async (dropFile: DropAreaFileType) => {
      // ファイルは最初の１つだけ
      if (fileFileId.value[props.resultIndex][props.kartePartsIndex].length > 0) {
        return
      }

      try {
        await addKarteFile(props.resultIndex, props.kartePartsIndex, dropFile)
      } catch (e) {
        await append('error', e.message)
      }
    }

    const onDropError = async (err: string) => {
      await append('error', err)
    }

    const onDeleteImage = async () => {
      if (fileFileId.value[props.resultIndex][props.kartePartsIndex].length === 0) {
        return
      }

      try {
        await deleteKarteFile(props.resultIndex, props.kartePartsIndex, 0)
      } catch (e) {
        await append('error', e.message)
      }
    }

    return {
      MaxAttachFileMega,
      fileFileId,
      text,
      fileMap,
      onImage,
      onDropError,
      onDeleteImage
    }
  }
})
